var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{style:(("z-index: " + _vm.zIndex)),attrs:{"fixed":"","right":"","stateless":"","temporary":"","overlay-color":"white","width":_vm.width,"value":_vm.open}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }